enum MessageEnum {
  Broadcast = "broadcast",
  Update = "update",
  Logout = "logout",
}

export default MessageEnum;
